import { FormattedMessage } from 'react-intl'
import { FilterDropdownItemProps } from '@carto/meridian-ds/components'

import { CommonPrivacy } from 'features/common/types'
import PrivacyIcon from './PrivacyIcon'

export const PrivatePrivacy: FilterDropdownItemProps = {
  id: CommonPrivacy.Private,
  'aria-label': 'private',
  label: <FormattedMessage id="common.shareDialog.privateOption" />,
  description: <FormattedMessage id="common.shareDialog.privateDesc" />,
  startAdornment: <PrivacyIcon privacy={CommonPrivacy.Private} border />,
  iconColor: 'default'
}

export const SharedPrivacy: FilterDropdownItemProps = {
  id: CommonPrivacy.Shared,
  'aria-label': 'shared',
  label: <FormattedMessage id="common.shareDialog.sharedOption" />,
  description: <FormattedMessage id="common.shareDialog.sharedDescShort" />,
  startAdornment: <PrivacyIcon privacy={CommonPrivacy.Shared} border />,
  iconColor: 'default'
}

export const PublicPrivacy: FilterDropdownItemProps = {
  id: CommonPrivacy.Public,
  'aria-label': 'public',
  label: <FormattedMessage id="common.shareDialog.publicOption" />,
  description: <FormattedMessage id="common.shareDialog.publicDesc" />,
  startAdornment: <PrivacyIcon privacy={CommonPrivacy.Public} border />,
  iconColor: 'default'
}
